var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form',{attrs:{"inline":""}},[_c('ChangeStateSelect',{staticClass:"mr-2",attrs:{"ticket":this.ticket},on:{"changeState":childVal => {
    _vm.transition = childVal.transition
  }}}),(this.ticket.propers_estats.find(estat => estat.trigger == 'markDuplicated'))?_c('MarkDuplicatedModal',{attrs:{"originTicket":this.ticket.id,"showDuplicatedModal":this.transition == 'markDuplicated'},on:{"updateNewTicketAssigned":childVal => {
    _vm.newTicketAssigned = childVal
  }}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }